import { Component, Input } from '@angular/core';
import { EMPTY, Observable } from 'rxjs';
import { AccountBaseService } from '../account-base-service';
import { AutocompleteComponent } from '../../ui/autocomplete/autocomplete.component';
import { AccountHintData } from '../account.model';
import { ProductCode } from '../../product/product.model';

@Component({
    selector: 'ifc-account-case-number-input',
    templateUrl: '../../ui/autocomplete/autocomplete.component.html',
    styleUrls: ['../../ui/autocomplete/autocomplete.component.css'],
    standalone: false
})
export class AccountCaseNumberInputComponent extends AutocompleteComponent {

  @Input()
  productCode: ProductCode;

  @Input()
  excludedProductCode: ProductCode;

  @Input()
  entityId: number;

  constructor(private accountService: AccountBaseService) {
    super();
  }

  label = 'Case number';

  optionFilter: (input: string | AccountHintData) => Observable<any[]> =
    input => input
      ? this.accountService.queryHints({
        externalId: !!input ? (typeof input !== 'string' ? input.externalId : input) : null,
        productCode: this.productCode,
        entityId: this.entityId,
        excludedProductCode: this.excludedProductCode,
        sortField: 'externalId'
      })
      : EMPTY;

  optionLabelKey = 'externalId';
}
